import { jsx as a, jsxs as y, Fragment as L } from "react/jsx-runtime";
import { withZod as u } from "@made-people/react-prop-guard";
import P, { useMemo as $, useState as v, useEffect as N } from "react";
import { z as e } from "zod";
import { tickerStyling as F, fadeStyling as I, staticStyling as q } from "./index-blueprint.es.js";
import { withManagedProps as d } from "@made-people/managed-props";
import { useLink as T } from "@made-people/grease-link";
import { motion as w, AnimatePresence as A } from "motion/react";
import G from "clsx";
import { Markdown as S } from "@made-people/blueprint-markdown";
import "@made-people/blueprint";
const m = {
  tickerWrap: {
    overflow: "hidden",
    whiteSpace: "nowrap"
  },
  ticker: {
    display: "inline-flex",
    animation: "marquee 80s linear infinite"
  },
  group1: {
    display: "inline-flex",
    position: "relative",
    left: "0%",
    animation: "swap 80s linear infinite"
  },
  group2: {
    display: "inline-flex"
  },
  item: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}, j = e.object({
  variants: e.custom().optional(),
  content: e.array(e.object({ label: e.string() })).optional(),
  duration: e.number().optional(),
  link: e.object({ href: e.string().optional() }).optional()
}), b = P.memo(
  ({ content: t, groupStyle: n, slots: r, styles: i, repeatCount: o = 5 }) => {
    const c = $(() => Array.from({ length: o }).flatMap(
      (g, s) => t.map((h, p) => {
        const l = s * t.length + p;
        return /* @__PURE__ */ a(
          w.span,
          {
            "data-index": `${s}-${p}`,
            style: i.item,
            className: r.item,
            initial: { opacity: 0, y: -40 },
            animate: { opacity: 1, y: 0 },
            transition: {
              delay: l * 0.02,
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ a("span", { className: r.label, children: h.label })
          },
          `${s}-${p}`
        );
      })
    ), [t, o, r.item, r.label, i.item]);
    return /* @__PURE__ */ a("span", { style: n, children: c });
  }
);
b.displayName = "TickerGroup";
const W = d(
  "TopbarTicker",
  u(j, (t) => {
    var o, c;
    if (!(t != null && t.content) || t.content.length === 0)
      return null;
    const n = F.main.styles(t.variants), r = T(), i = t.content ?? [];
    return /* @__PURE__ */ y(L, { children: [
      /* @__PURE__ */ a("style", { children: `
            @keyframes marquee {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-100%);
              }
            }
            @keyframes swap {
              0%, 50% {
                left: 0%;
              }
              50.01%, 100% {
                left: 100%;
              }
            }
          ` }),
      /* @__PURE__ */ y(
        "section",
        {
          style: m.tickerWrap,
          className: G("relative", n.wrapper),
          children: [
            /* @__PURE__ */ y("div", { style: m.ticker, className: n.ticker, children: [
              /* @__PURE__ */ a(
                b,
                {
                  content: i,
                  groupStyle: m.group1,
                  slots: n,
                  styles: m
                }
              ),
              /* @__PURE__ */ a(
                b,
                {
                  content: i,
                  groupStyle: m.group2,
                  slots: n,
                  styles: m
                }
              )
            ] }),
            ((o = t.link) == null ? void 0 : o.href) && /* @__PURE__ */ a(
              r,
              {
                href: (c = t.link) == null ? void 0 : c.href,
                className: "w-full h-full absolute block top-0 left-0"
              }
            )
          ]
        }
      )
    ] });
  })
), x = e.object({
  variants: e.custom().optional(),
  content: e.array(
    e.object({
      label: e.string().optional(),
      customContent: e.custom().optional(),
      link: e.object({
        target: e.string().optional(),
        href: e.string().optional()
      }).optional()
    })
  ).optional(),
  interval: e.number().optional()
}), X = d(
  "TopbarFade",
  u(
    {
      schema: x,
      defaultProps: {
        interval: 5e3
      }
    },
    ({ content: t, variants: n, interval: r }) => {
      const i = I.main.styles(n), o = T(), [c, g] = v(0), s = t ? t.length : 0, [h, p] = v(!1);
      return N(() => p(!0), []), N(() => {
        if (s <= 1)
          return;
        const l = setInterval(
          () => g((f) => (f + 1) % s),
          r
        );
        return () => clearInterval(l);
      }, [s, r]), t != null && t.length ? /* @__PURE__ */ a("div", { className: i.wrapper, children: /* @__PURE__ */ a("div", { className: i.fade, children: t && t.map((l, f) => {
        var k;
        return /* @__PURE__ */ a(A, { mode: "popLayout", children: c === f && /* @__PURE__ */ a(
          w.span,
          {
            className: i.item,
            initial: h ? { opacity: 0, y: "100%" } : !1,
            animate: { opacity: 1, y: "0" },
            exit: { opacity: 0, y: "-100%" },
            transition: {
              duration: 0.5,
              ease: "easeInOut"
            },
            children: l.customContent ? l.customContent : (k = l.link) != null && k.href ? /* @__PURE__ */ a(o, { href: l.link.href, children: /* @__PURE__ */ a(
              S,
              {
                content: l.label,
                className: i.label
              }
            ) }) : /* @__PURE__ */ a(
              S,
              {
                content: l.label,
                className: i.label
              }
            )
          }
        ) }, f);
      }) }) }) : null;
    }
  )
), M = e.object({
  variants: e.custom().optional(),
  content: e.array(
    e.object({
      label: e.string().optional()
    })
  ).optional()
}), z = d(
  "TopbarStatic",
  u(M, ({ ...t }) => {
    const n = q.main.styles(t.variants);
    return /* @__PURE__ */ a("div", { className: n.wrapper, children: /* @__PURE__ */ a("div", { className: n.static, children: t.content && t.content.map((r, i) => /* @__PURE__ */ a("div", { className: n.item, children: /* @__PURE__ */ a("span", { className: n.label, children: r.label }) }, i)) }) });
  })
), C = e.discriminatedUnion("template", [
  j.extend({
    template: e.literal("ticker")
  }),
  M.extend({
    template: e.literal("static")
  }),
  x.extend({
    template: e.literal("fade")
  })
  // template2Schema...
]), E = u(C, (t) => {
  switch (t.template) {
    case "ticker":
      return /* @__PURE__ */ a(W, { ...t });
    case "fade":
      return /* @__PURE__ */ a(X, { ...t });
    case "static":
      return /* @__PURE__ */ a(z, { ...t });
    default:
      return null;
  }
}), H = "ticker", O = e.object({
  settings: C.optional()
}), tt = d(
  "Topbar",
  u(O, (t) => {
    const n = t.settings || { template: H };
    return /* @__PURE__ */ a(E, { ...n });
  })
);
export {
  E as SelectTemplate,
  tt as Topbar,
  X as TopbarFade,
  z as TopbarStatic,
  W as TopbarTicker,
  x as fadeSchema,
  M as staticSchema,
  m as styles,
  j as tickerSchema,
  O as topbarPropsSchema,
  C as topbarSchema
};
//# sourceMappingURL=index.es.js.map
